import React from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

import { COLORS } from '../../../constants/colors';


const StillWaitingHeader = ({ }) => {
    const { t } = useTranslation();

    const mobileView = window.innerWidth < 650;

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: mobileView ? 'column' : 'row',
                width: '100%'
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'left',
                    //minWidth: '70%',
                    //maxWidth: '80%'
                }}
            >
                <Typography variant='h6' style={{ color: COLORS.blue, fontWeight: 'bold' }}>
                    {t('newFacility:headers.waiting.title')}
                </Typography>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        marginTop: '1rem'
                    }}
                >
                    <CheckCircleOutlineIcon style={{ color: COLORS.green }} />
                    <Typography variant="body2" style={{ color: COLORS.blue, fontWeight: 'bold', marginLeft: '0.5rem' }}>
                        {t('newFacility:headers.waiting.verified')}
                    </Typography>
                </div>
                <Typography variant='body2' style={{ color: COLORS.blue, marginTop: '1rem' }}>
                    {t('newFacility:headers.waiting.desc1')}
                </Typography>
                <Typography variant='body2' style={{ color: COLORS.blue, marginTop: '0.5rem' }}>
                    {t('newFacility:headers.waiting.desc2')}
                </Typography>
            </div>
        </div>
    );
};

export default StillWaitingHeader;